import type { BranchShiftStatus, ChannelAvailabilityStatus, DayOfWeek } from '@/backend/market'

export class ChannelShiftPeriodEntity {
  id?: string | null
  startTimeDayOfWeek?: DayOfWeek
  startTime?: string
  endTimeDayOfWeek?: DayOfWeek
  endTime?: string
  status?: BranchShiftStatus
}

export class ChannelShiftEntity {
  dayOfWeek?: DayOfWeek
  overallShiftStatus?: BranchShiftStatus
  periods?: ChannelShiftPeriodEntity[] | null
}

export class ChannelWorkingHoursEntity {
  channelId?: number
  regionId?: number
  manualStatus?: ChannelAvailabilityStatus
  manualStatusExpiresAt?: string | null
  currentStatus?: ChannelAvailabilityStatus
  shiftDays?: ChannelShiftEntity[] | null
}
